<form [formGroup]="form" novalidate>

    <div class="row">
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Sync Date</label>
                <div class="col-sm-9">
                     <input type="date" formControlName="syncdate" class="form-control form-control-sm"
                                placeholder="Sync Date">
                </div>
            </div>
        </div>
         <div class="col-md-6" >
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Creation Date</label>
                <div class="col-sm-9">
                    <input type="date" formControlName="creationDate" class="form-control form-control-sm"
                                placeholder="Creation Date">
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Salesman</label>
                <div class="col-sm-9">
                     <app-multiautocomplete isSingle="false" [options]="salesmanList" (selectionchanged)="selectionchangedSalesman()"
                                    [control]="SalesmanFormControl" text="salesman_name" id="id"
                                    placeholder="Search Salesman">
                                </app-multiautocomplete>
                </div>
            </div>
        </div>
        <div class="col-md-6" >
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Brachplant</label>
                <div class="col-sm-9">
                    <app-multiautocomplete isSingle="false" objectName="code-root" [options]="storageLocation"
                        (selectionchanged)="selectionchangedstorageLocation()" [control]="branchplantsFormControl"
                        text="name" id="id" param1="code" param2="name" formControlName="storage_location_id">
                    </app-multiautocomplete>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Invoice NO</label>
                <div class="col-sm-9">
                    <input type="text" formControlName="invoice_no" class="form-control form-control-sm"
                        placeholder="Invoice NO">
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Invoice Date Range</label>
                <!-- <div class="col-sm-9" style="display:flex;">
                    <input type="date" formControlName="startdate" class="form-control form-control-sm" placeholder="Start Date">
                   &nbsp; &nbsp;<span>_</span>&nbsp;&nbsp;
                   <input type="date" formControlName="enddate" class="form-control form-control-sm" placeholder="End Date">
                </div> -->
                <div class="col-sm-9">
                    <div class="row">
                        <div class="col">
                            <input type="date" formControlName="startdate" class="form-control form-control-sm"
                                placeholder="Start Date">
                        </div>
                        <div class="col-1 p-0">
                            &nbsp; &nbsp;<span>_</span>&nbsp;&nbsp;
                        </div>
                        <div class="col">
                            <input type="date" formControlName="enddate" class="form-control form-control-sm"
                                placeholder="End Date">
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Order NO</label>
                <div class="col-sm-9">
                    <input type="text" formControlName="order_no" class="form-control form-control-sm"
                        placeholder="Order NO" />
                </div>
            </div>
        </div>
        <!-- <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Total Range</label>
                <div class="col-sm-9" style="display:flex;">
                    <input type="text" formControlName="startrange" class="form-control form-control-sm"
                        placeholder="Start Range">
                    &nbsp; &nbsp;<span>_</span>&nbsp;&nbsp;
                    <input type="text" formControlName="endrange" class="form-control form-control-sm"
                        placeholder="End Range">
                </div>
            </div>
        </div> -->

        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Customer</label>
                <div class="col-sm-9">
                     <app-multiautocomplete [options]="customers" [control]="CustomersFormControl" text="" id="id" formControlName="customer_id"
                objectName="user-root" param1="customer_code" param2="name" (selectionchanged)="selectionchangedCustomer()" >
              </app-multiautocomplete>
               <!-- <mat-autocomplete appOptionScroll (optionsScroll)="onScroll()"
                    (optionSelected)="getCustomerLobList($event.option.value)" #auto="matAutocomplete"
                    (opened)="checkFormValidation('order')" [displayWith]="customerControlDisplayValue"> -->
                </div>
            </div>
        </div>
<div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Customer LPO NO</label>
                <div class="col-sm-9">
                    <input type="text" formControlName="customer_lpo_no" class="form-control form-control-sm"
                        placeholder="Customer LPO No" />
                </div>
            </div>
        </div>

        <!-- <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Status</label>
                <div class="col-sm-9">
                    <mat-select class="form-control form-control-sm" formControlName="current_stage">
                        <mat-option *ngFor="let item of statusList" [value]="item.id">
                            {{ item.name }}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
        </div> -->
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Service Channel</label>
                <div class="col-sm-9">
                    <mat-select multiple class="form-control form-control-sm" formControlName="channel_name">
                                    <mat-option *ngFor="let item of channelList" [value]="item.id">
                                    {{ item?.name }}
                                    </mat-option>
                                </mat-select>
                </div>
            </div>
        </div>
          <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Item</label>
                <div class="col-sm-9">
                     <app-multiautocomplete isSingle="false" [options]="filteredItems" [control]="itemsFormControl" text="" formControlName="item_id"
                  id="id" objectName="item-portfolio-root" (selectionchanged)="selectionchangedItems()" param1="item_code"
                  param2="item_name">
                </app-multiautocomplete>
                    <!-- <angular2-multiselect [data]="items" [formControl]="itemsFormControl"
            [settings]="settings" (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)"
            (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)">
            <c-search>
              <ng-template>
                <input type="text" (input)="onSearch($event)" placeholder="Search Items"
                  style="border: none;width: 100%; height: 100%;outline: none;" />
              </ng-template>
            </c-search>
            <c-item>
              <ng-template let-item="item">
                <label style="color: #333;width: 150px;">{{item.itemName}}</label>
              </ng-template>
            </c-item>
          </angular2-multiselect> -->
                </div>
            </div>
        </div>
         <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">ERP Status</label>
                <div class="col-sm-9">
                     
            <mat-select multiple class="form-control form-control-sm" formControlName="erp_status">
              <mat-option value="Not Posted">Not Posted</mat-option>
              <mat-option value="Posted">Posted</mat-option>
              <mat-option value="Failed">Fail</mat-option>
            </mat-select>
         
                </div>
            </div>
        </div>
    </div>
</form>